import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.sociallinks.title': {
    id: 'profile.sociallinks.title',
    defaultMessage: 'My Social Links',
    description: 'A section of a user profile social links title',
  },
  'profile.sociallinks.social.links': {
    id: 'profile.sociallinks.social.links',
    defaultMessage: 'Social Links',
    description: 'A section of a user profile',
  },
  'profile.social.media': {
    id: 'profile.social.media',
    defaultMessage: 'Social media',
    description: 'A section of a user Social media',
  },
});

export default messages;
